<section class="section--public background--wave">
  <div class="relative">
    <div class="tabs-bar">
      <nav mat-tab-nav-bar class="tabs-nnki">
        <a
          mat-tab-link
          [routerLink]="tab.routerLink"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
          *ngFor="let tab of tabRoutes"
        >
          <span [ngClass]="{ 'hidden sm:block': tab.labelMobile }">
            {{ tab.label | translate }}
          </span>
          <span class="sm:hidden" *ngIf="tab.labelMobile">
            {{ tab.labelMobile | translate }}
          </span>
        </a>
      </nav>
    </div>
    <div
      [@routeSlide]="routingService.routeTrigger$ | async"
      (@routeSlide.done)="routingService.slideEnded()"
      class="container-route"
      (panLeft)="routingService.onPan($event)"
      (panRight)="routingService.onPan($event)"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</section>
